import React from 'react';
import { Route } from 'react-router-dom';
import AdminList from '../../ListPages/AdminList.js';
import UserList from '../../ListPages/RobotUsers/RobotUsersList1.js';
import RobotList from '../../ListPages/RobotUsers/RobotUsersList2.js';
import UsersList from '../../ListPages/UserList/UsersList1.js';
import UserDetailsList from '../../ListPages/UserList/UsersList2.js';
import UpdateUser from '../../ListPages/UserList/UsersList2.js';
import RobotMsgList1 from '../../ListPages/RobotMsg/RobotMsgList1.js';
import RobotMsgList2 from '../../ListPages/RobotMsg/RobotMsgList2.js';
import RobotMsgList3 from '../../ListPages/RobotMsg/RobotMsgList3.js';
import BookSession from '../../BookingRobot/BookSession.js';
import Sessiondetails from '../../BookingRobot/Sessiondetails.js';
import DetailsView from '../../BookingRobot/DetailsView.js';
import RobotForm from '../../DetailsUplode/CreateRobotForUser.js';
import RobotVersionList1 from '../../ListPages/RobotVersion/RobotVersionList1.js';
import RobotVersionList2 from '../../ListPages/RobotVersion/RobotVersionList2.js';

export const usersRobotsRoutes = [
  <Route key="users-list" path="/users-list" element={<UsersList />} />,
  <Route key="user-details" path="/user-details/:email" element={<UserDetailsList />} />,
  <Route key="update-user" path="/update-user" element={<UpdateUser />} />,
  <Route key="admin-user" path="/admin-user" element={<AdminList />} />,
  <Route key="robot-form" path="/robot-form" element={<RobotForm />} />,
  <Route key="user-robot" path="/user-robot" element={<UserList />} />,
  <Route key="robots-email" path="/robots/:email" element={<RobotList />} />,
  <Route key="robot-msg-list" path="/RobotMsgList" element={<RobotMsgList1 />} />,
  <Route key="robot-msg-robot" path="/robot/:robotId" element={<RobotMsgList2 />} />,
  <Route key="camera-images" path="/camera-images/:messageId" element={<RobotMsgList3 />} />,
  <Route key="robot-booking" path="/Robot-Booking" element={<BookSession />} />,
  <Route key="booking-details" path="/Booking-details" element={<Sessiondetails />} />,
  <Route key="sessions-id" path="/sessions/:id" element={<DetailsView />} />,
  <Route key="update-apppermission" path="/update-apppermession" element={<RobotVersionList1 />} />,
  <Route key="appdetails" path="/appdetails/:emailId" element={<RobotVersionList2 />} />,
];
